"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const SaveIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 6827 6827" }),
    react_1.default.createElement("path", { d: "M3713 1092l0 1200c0,23 9,44 25,60 15,15 36,25 60,25l478 0c23,0 44,-9 60,-25 15,-15 25,-36 25,-60l0 -1200c0,-23 -9,-44 -25,-60 -15,-15 -36,-25 -60,-25l-478 0c-23,0 -44,9 -60,25 -15,15 -25,36 -25,60z" }),
    react_1.default.createElement("path", { d: "M1067 5973l4692 0c118,0 214,-96 214,-214l0 -4264 -642 -642 -720 0 0 1677 -2396 0 0 -1677 -1148 0c-118,0 -214,96 -214,214l0 4692c0,118 96,214 214,214zm1038 -2304l2617 0c108,0 196,88 196,196l0 1505c0,108 -88,196 -196,196l-2617 0c-108,0 -196,-88 -196,-196l0 -1505c0,-108 88,-196 196,-196z" })));
exports.SaveIcon = SaveIcon;
exports.default = exports.SaveIcon;
